const ADMIN_INVOICES = "ADMIN_INVOICES";
const ADMIN_INVOICES_SUCCESS = "ADMIN_INVOICES_SUCCESS";
const ADMIN_INVOICES_FAILURE = "ADMIN_INVOICES_FAILURE";
const CLEAR_ADMIN_INVOICES = "CLEAR_ADMIN_INVOICES";

const AdminInvoicesSymbols = {
  ADMIN_INVOICES_SUCCESS,
  ADMIN_INVOICES_FAILURE,
  ADMIN_INVOICES,
  CLEAR_ADMIN_INVOICES,
};
export default AdminInvoicesSymbols;
